import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button, IconButton } from '@mui/material';
import { keyframes } from '@emotion/react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Banner from '../components/Banner';
import videoFile from '../assets/video-quienes-somos.mp4';
import backgroundImage from '../assets/background.jpeg';

// Imágenes de trabajos
import trabajo1 from '../assets/trabajo1.png';
import trabajo2 from '../assets/trabajo2.png';
import trabajo3 from '../assets/trabajo3.png';
import trabajo4 from '../assets/trabajo4.png';
import trabajo5 from '../assets/trabajo5.png';
import trabajo6 from '../assets/trabajo6.png';
import trabajo7 from '../assets/trabajo7.png';
import trabajo8 from '../assets/trabajo8.png';
import trabajo9 from '../assets/trabajo9.png';
import trabajo10 from '../assets/trabajo10.png';

const trabajos = [
  { src: trabajo1, alt: 'Proyecto 1' },
  { src: trabajo2, alt: 'Proyecto 2' },
  { src: trabajo3, alt: 'Proyecto 3' },
  { src: trabajo4, alt: 'Proyecto 4' },
  { src: trabajo5, alt: 'Proyecto 5' },
  { src: trabajo6, alt: 'Proyecto 6' },
  { src: trabajo7, alt: 'Proyecto 7' },
  { src: trabajo8, alt: 'Proyecto 8' },
  { src: trabajo9, alt: 'Proyecto 9' },
  { src: trabajo10, alt: 'Proyecto 10' },
];

// Animación suave para las cards (fade + slide up)
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const Inicio = ({ onGoToServicios, onGoToContacto }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const visibleCards = Math.min(3, trabajos.length);

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? trabajos.length - visibleCards : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev >= trabajos.length - visibleCards ? 0 : prev + 1
    );
  };

  const handleDotClick = (index) => {
    // Aseguramos que el índice de inicio no haga "ventana vacía"
    if (index > trabajos.length - visibleCards) {
      setCurrentIndex(trabajos.length - visibleCards);
    } else {
      setCurrentIndex(index);
    }
  };

  // Obtener las N imágenes visibles
  const getVisibleImages = () => {
    const result = [];
    for (let i = 0; i < visibleCards; i++) {
      result.push(trabajos[(currentIndex + i) % trabajos.length]);
    }
    return result;
  };

  // Autoplay con pausa cuando hover
  useEffect(() => {
    if (isHovered) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev >= trabajos.length - visibleCards ? 0 : prev + 1
      );
    }, 5000); // cada 5 segundos

    return () => clearInterval(interval);
  }, [isHovered]);

  return (
    <Box>
      {/* BANNER */}
      <Banner
        onGoToServicios={onGoToServicios}
        onGoToContacto={onGoToContacto}
      />

      {/* SECCIÓN QUIÉNES SOMOS */}
<Box sx={{ py: 8 }}>
  <Container maxWidth="lg">
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' }, // 👈 columna en móvil, fila en desktop
        gap: 4,
        width: '100%',
        alignItems: { xs: 'center', md: 'stretch' }, // 👈 centrado en móvil
      }}
    >
      {/* TEXTO IZQUIERDA */}
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'Outfit, var(--title-font)',
            fontWeight: 700,
            fontSize: { xs: '1.6rem', md: '1.9rem' },
            letterSpacing: 1,
            mb: 1,
          }}
        >
          ¿QUIÉNES SOMOS?
        </Typography>

        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              width: 130,
              height: 3,
              backgroundColor: '#a9cf47',
              mb: '1px',
            }}
          />
          <Box
            sx={{
              width: 130,
              height: 3,
              backgroundColor: '#3c77b6',
            }}
          />
        </Box>

        <Typography
          sx={{
            fontSize: 15.5,
            lineHeight: 1.7,
            color: '#4b5563',
            fontFamily: 'Poppins, var(--text-font)',
          }}
        >
          Somos una casa productora audiovisual especializada en la
          creación de contenido profesional para empresas, instituciones
          y eventos en general.
          <br />
          <br />
          Nuestro compromiso es comunicar ideas con claridad, impacto y
          gran calidad, convirtiendo cada proyecto en una herramienta
          efectiva de comunicación y conexión.
        </Typography>
      </Box>

      {/* VIDEO DERECHA */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: { xs: 'center', md: 'flex-end' }, // 👈 centrado en móvil
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 520,
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: '0 18px 40px rgba(0,0,0,0.15)',
          }}
        >
          <video
            src={videoFile}
            controls
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
      </Box>
    </Box>
  </Container>
</Box>


      {/* IMAGEN TRANSICIÓN */}
      <Box
        sx={{
          width: '100%',
          height: { xs: 160, md: 220 },
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      {/* SECCIÓN NUESTRO TRABAJO */}
      <Box sx={{ py: 8 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', maxWidth: 720, mx: 'auto' }}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: 'Outfit, var(--title-font)',
                fontWeight: 700,
                fontSize: { xs: '1.6rem', md: '1.9rem' },
                letterSpacing: 1,
                mb: 1,
              }}
            >
              NUESTRO TRABAJO
            </Typography>

            <Box sx={{ mb: 3 }}>
              <Box
                sx={{
                  width: 130,
                  height: 3,
                  backgroundColor: '#a9cf47',
                  mx: 'auto',
                  mb: '1px',
                }}
              />
              <Box
                sx={{
                  width: 130,
                  height: 3,
                  backgroundColor: '#3c77b6',
                  mx: 'auto',
                }}
              />
            </Box>

            <Typography
              sx={{
                fontSize: 15.5,
                lineHeight: 1.7,
                color: '#4b5563',
                fontFamily: 'Poppins, var(--text-font)',
              }}
            >
              Conoce algunos de los proyectos que hemos producido para marcas,
              empresas e instituciones que confiaron en nosotros para comunicar
              su visión.
            </Typography>
          </Box>

          {/* CARRUSEL 3 CARDS + AUTOPLAY + DOTS */}
          <Box
            sx={{
              mt: 6,
              position: 'relative',
              maxWidth: 1000,
              mx: 'auto',
              px: 6,
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* Flecha izquierda */}
            <IconButton
              onClick={handlePrev}
              sx={{
                position: 'absolute',
                left: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: '#ffffff',
                boxShadow: '0 8px 20px rgba(0,0,0,0.18)',
                '&:hover': { backgroundColor: '#f3f4f6' },
              }}
            >
              <FaChevronLeft />
            </IconButton>

            {/* Cards visibles */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 3,
              }}
            >
              {getVisibleImages().map((item, index) => {
                const isCenter = index === 1; // card central
                return (
                  <Box
                    key={`${item.alt}-${index}-${currentIndex}`}
                    sx={{
                      width: '30%',
                      minWidth: 200,
                      maxWidth: 260,
                      borderRadius: 2,
                      overflow: 'hidden',
                      backgroundColor: '#ffffff',
                      boxShadow: isCenter
                        ? '0 16px 35px rgba(0,0,0,0.25)'
                        : '0 10px 25px rgba(0,0,0,0.15)',
                      transform: isCenter ? 'scale(1.05)' : 'scale(0.95)',
                      transition: 'transform 0.35s ease, box-shadow 0.35s ease',
                      animation: `${fadeInUp} 0.35s ease`,
                    }}
                  >
                    <img
                      src={item.src}
                      alt={item.alt}
                      style={{
                        width: '100%',
                        height: '220px',
                        objectFit: 'cover',
                        display: 'block',
                      }}
                    />
                  </Box>
                );
              })}
            </Box>

            {/* Flecha derecha */}
            <IconButton
              onClick={handleNext}
              sx={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: '#ffffff',
                boxShadow: '0 8px 20px rgba(0,0,0,0.18)',
                '&:hover': { backgroundColor: '#f3f4f6' },
              }}
            >
              <FaChevronRight />
            </IconButton>

            {/* Dots guía visual + clicables */}
            <Box
              sx={{
                mt: 3,
                display: 'flex',
                justifyContent: 'center',
                gap: 1,
              }}
            >
              {trabajos.map((_, index) => (
                <Box
                  key={index}
                  onClick={() => handleDotClick(index)}
                  sx={{
                    width: index === currentIndex ? 16 : 8,
                    height: 8,
                    borderRadius: 999,
                    backgroundColor:
                      index === currentIndex ? '#3c77b6' : '#d1d5db',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                  }}
                />
              ))}
            </Box>
          </Box>
        </Container>
      </Box>

      {/* SECCIÓN FINAL CTA */}
      <Box sx={{ mt: 8, py: 8, backgroundColor: '#000000' }}>
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: 'Outfit, var(--title-font)',
                fontWeight: 700,
                fontSize: { xs: '1.6rem', md: '1.9rem' },
                letterSpacing: 1,
                mb: 3,
                color: '#ffffff',
              }}
            >
              Tu historia, nuestra cámara
            </Typography>

            <Button
              onClick={onGoToContacto}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 15,
                borderRadius: '4px',
                px: 4,
                py: 1.2,
                backgroundColor: '#3a79ba',
                color: '#000000',
                '&:hover': {
                  backgroundColor: '#315f94',
                },
              }}
            >
              Contacto
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Inicio;
